<template>
  <div>
    <div
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font" style="margin-bottom: 10px">
          <img
            src="../../static/images/chaxun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            活动品种
          </span>
        </p>
        <div class="row ml-2 mb-2 mt-2" style="position: relative">
          <div class="col-lg-8">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="params.ypmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">规格:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="params.gg"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="params.cdmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="row">
              <div class="col-lg-6 p-0 text-center font">代理商号:</div>
              <div class="col-lg-6 p-0">
                <input
                  type="text"
                  class="form-control font"
                  v-model="params.clerkno"
                  style="height: 1.5rem"
                  @keydown.enter="searchEnterFun"
                />
              </div>
            </div>
          </div>
          <div
            style="
              margin-top: 10px;
              margin-left: 10px;
              position: absolute;
              top: -10px;
              right: 30px;
            "
          >
            <el-button type="primary" style="padding: 5px 8px" @click="search()"
              >搜索</el-button
            >
          </div>
        </div>
        <div v-if="showPage">
          <table class="table table-striped table-hover" ref="print">
            <thead>
              <tr style="white-space: nowrap">
                <th>药品名称</th>
                <th>折扣</th>
                <th>药品编号</th>
                <th>规格</th>
                <th>产地</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in tableData" :key="index">
                <td>{{ item.ypmc }}</td>
                <td>{{ (item.onlinezk * 100).toFixed(1) + "折" }}</td>
                <td>{{ item.ypbh }}</td>
                <td>{{ item.gg }}</td>
                <td>{{ item.cdmc }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <img
            src="../../static/images/wushuju.jpg"
            style="width: 300px; height: 300px; display: block; margin: 0 auto"
            alt=""
          />
        </div>
        <div
          style="
            position: absolute;
            left: 50%;
            transform: translate(-50%, 0);
            bottom: 0px;
          "
        >
          <el-pagination
            @current-change="pagechange"
            :current-page.sync="current"
            :page-size="params.PageSize"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div>
      <transition name="fade">
        <loading v-if="isLoading"></loading>
      </transition>
    </div>
  </div>
</template>
<script>
import vPagination from "../components/Pagination.vue";
import Loading from "../components/Loading.vue";

export default {
  name: "SaleQuery",
  data() {
    return {
      params: {
        ypmc: "",
        cdmc: "",
        gg: "",
        clerkno: "",
        hdid: null,
        PageSize: 20,
        PageIndex: 1,
      },
      Height: 0, //搜索返回的清单
      isLoading: false,
      showPage: true,
      tableData: [],
      total: 0, //总条数
      current: 1, //当前页
    };
  },
  components: {
    vPagination,
    Loading,
  },
  computed: {},
  methods: {
    getClerkGoodsForward: async function () {
      const that = this;
      that.isLoading = true;
      const { data: res } = await this.$http.post("DsApi/GetHdxq", this.params);
      that.isLoading = false;
      if (res.isok) {
        this.total = res.totalCount;
        that.tableData = res.list;
      }
    },
    pagechange(current) {
      this.params.PageIndex = current;
      try {
        this.getClerkGoodsForward();
      } catch (error) {
        console.error("Failed to fetch clerk goods forward:", error);
      }
    },
    search() {
      this.current = 1;
      this.params.PageIndex = 1;
      this.getClerkGoodsForward();
    },
  },
  mounted() {
    this.params.hdid = Number(this.$route.query.hdid);
    this.getClerkGoodsForward();

    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
  },
};
</script>
<style scoped>
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
.table {
  margin-bottom: 60px;
}
.hei {
  height: 1.5rem;
}
.font {
  font-size: 15px;
}
.font_yz {
  font-size: 1px;
  color: red;
}
.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}
.money {
  color: red;
  font-weight: 500;
}
.span_close:hover {
  color: #3190e8;
}
.totalNum {
  color: green;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/pages/hdpz.vue